export const emailRule = (v) =>
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    v,
  ) || 'rule_email';

export const userNameRule = (value) => {
  const trimmed = value?.trim();

  if (!trimmed || trimmed.length < 3) return 'rule_name';
  if (trimmed.length > 25) return 'rule_name_max';
  if (/^\s|\s$/.test(value)) return 'rule_name_start';
  if (/\s{2,}/.test(value)) return 'rule_name_multiple';
  if (!/^[a-zA-Zа-яА-ЯёЁ\s]+$/.test(value)) return 'rule_name_letters';

  return true;
};

export const teamNameRule = (value) => {
  const trimmed = value?.trim();

  if (!trimmed || trimmed.length < 3) return 'rule_team_name';
  if (trimmed.length > 25) return 'rule_team_name_max';
  if (/^\s|\s$/.test(value)) return 'rule_team_name_start';
  if (/\s{2,}/.test(value)) return 'rule_team_name_multiple';
  if (!/^[a-zA-Zа-яА-ЯёЁ0-9 _-]+$/.test(value)) return 'rule_team_name_letters';

  return true;
};

export const passwordRule = (value) => {
  if (!/[a-z]/.test(value)) return 'rule_lowercase_letter';
  if (!/[A-Z]/.test(value)) return 'rule_uppercase_letter';
  if (!/[0-9]/.test(value)) return 'rule_number';
  if (!/[\W_]/.test(value)) return 'rule_special_character';
  if (value.length < 8) return 'rule_8_characters';

  return true;
};

export const passwordMatchRule = (value, password) =>
  value === password || 'rule_passwords_do_not_match';

export function validateServerErrors(setError, res) {
  const errors = res?.response?.data?.errors;
  if (!errors) return;

  for (const [key, message] of Object.entries(errors)) {
    if (message) {
      setError(key === 'slug' ? 'name' : key, { type: 'validate', message });
    }
  }
}

export function validateMinAmount(value, min) {
  if (value < min) {
    return 'rule_min_amount';
  }
  return true;
}

export function validateTransactionLimit(value, balanceLimit) {
  if (
    value != null &&
    balanceLimit != null &&
    balanceLimit !== '' &&
    Number(value) > Number(balanceLimit)
  ) {
    return 'rule_transaction_limit_exceeds_balance';
  }
  return true;
}

export function validateMaxAmount(value, max) {
  if (max != null && Number(value) > Number(max)) {
    return 'rule_max_amount';
  }
  return true;
}

export function validateMaxLength(value, max) {
  if (value?.length > max) {
    return JSON.stringify({
      key: 'rule_max_length',
      options: { max },
    });
  }
  return true;
}
